import { useParams } from "react-router-dom";
import Candidates from "@/pages/candidates/Candidate_Home";
import SingleCandidate from "@/pages/candidates/Single_Candidate";

const CandidatePage = () => {
  // Read the optional ":id" route param so we know
  // whether a specific candidate has been selected.
  const { id } = useParams();

  return (
    <div className="relative w-full h-full">
      {/* Fixed Candidates section - positioned within the content area (desktop) */}
      <div
        className="hidden xl:block xl:fixed xl:w-[350px]"
        style={{
          height: "calc(100vh - 64px)",
          top: "64px", // Match your header height
          left: "var(--sidebar-width)", // Match your dashboard sidebar width
        }}>
        <div className="xl:overflow-y-auto xl:h-full xl:pr-2 hide-scrollbar">
          <Candidates />
        </div>
      </div>

      {/* Single Candidate section with appropriate margin (desktop) */}
      <div className="hidden xl:block" style={{ marginLeft: "calc(350px)" }}>
        <div className="py-6">
          <SingleCandidate />
        </div>
      </div>

      {/* Mobile view - show list OR single candidate based on the route */}
      <div className="xl:hidden">
        {id ? <SingleCandidate /> : <Candidates />}
      </div>
    </div>
  );
};

export default CandidatePage;
